<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        v-if="$route"
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />

        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->
        <transition :name="routerTransition">
          <div
            v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
            class="router-header flex flex-wrap items-center md:flex hidden"
          >

            <!-- Menu Buttons -->
          <div class="flex">
            <!-- Close Button -->
            <!-- <template v-if="showCloseButton">
              <feather-icon
                icon="XIcon"
                class="m-0 cursor-pointer"
                @click="
                  $store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                "
              />
            </template> -->

            <!-- Toggle Buttons -->
            <template v-if="windowWidth >= 1200">
              <feather-icon
                id="btnVNavMenuMinToggler"
                class="mr-5 cursor-pointer"
                icon="AlignLeftIcon"
                svg-classes="stroke-current"
                @click="toggleReduce(!reduce)" />
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->

            <template>
              <div
                class="content-area__headingg"
                :class="{
                  'pr-4 border-0 md:border-r border-solid border-grey-light':
                    $route.meta.breadcrumb,
                }"
              >
                <h3 v-if="routeTitle">{{ routeTitle }}</h3>
                <h3 v-else>{{ customRouteTitle }}</h3>
              </div>
            </template>

            <!-- BREADCRUMB -->
            <vx-org-breadcrumb
              class="ml-4 md:block hidden"
              v-if="$route.meta.breadcrumb"
              :route="$route"
              :isRTL="$vs.rtl"
              :orgData="orgData"
            />

            <!-- <div class="vx-card ml-auto p-3 items-right" style="width: auto;">
                    <profile-drop-down />
                  </div> -->
          </div>
        </transition>

        <vs-spacer />

        <!-- <i18n /> -->

        <!-- <search-bar /> -->

        <!-- <cart-drop-down /> -->

        <!-- <notification-drop-down v-if="!isRouteMyOrganizations" /> -->

        <!-- <feather-icon icon="ActivityIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" @click.stop="activeActivitySidebar = !activeActivitySidebar; fetchOrgActivityLogData()" /> -->

        <user-profile-drop-down v-if="isRouteMyOrganizations" class="md:hidden" />
        <profile-drop-down v-else class="md:hidden" />

        <div
          class="ml-auto p-0 items-right md:flex hidden"
          style="width: auto"
        >
          <user-profile-drop-down v-if="isRouteMyOrganizations" />
          <profile-drop-down v-else />
        </div>
      </vs-navbar>

      <!--  Activity Sidebar -->
      <activity 
        :active="activeActivitySidebar" 
        :activityLogData="activityLogData" 
        @closeActivitySidebar="closeActivitySidebar" 
        :fetchingActivityLog="fetchingActivityLog"
      />
    </div>
  </div>
</template>


<script>
import Bookmarks from "./components/Bookmarks.vue";
// import I18n                 from './components/I18n.vue'
import SearchBar from "./components/SearchBar.vue";
// import CartDropDown         from './components/CartDropDown.vue'
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import UserProfileDropDown from "./components/UserProfileDropDown.vue";
import themeConfig         from '@/../themeConfig.js'
import VxOrgBreadcrumb from '../VxOrgBreadcrumb.vue'; 
import Activity from '../Activity/Main.vue';

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data (){
   return {
     routerTransition  : themeConfig.routerTransition || 'none',
     // routeTitle        : this.$route.meta.pageTitle
     activeActivitySidebar: false,
     activityLogData: [],
     fetchingActivityLog: false,
     clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
   }
  },
  components: {
    Bookmarks,
    // I18n,
    SearchBar,
    // CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
    UserProfileDropDown,
    VxOrgBreadcrumb,
    Activity
  },
  computed: {
    isRouteMyOrganizations() {
      return this.$route.name === 'my-organizations';
    },
    customRouteTitle() {
      return this.$store.state.organization.customRouteTitle;
    },
    routeTitle() {
      return this.$route.meta.pageTitle;
    },
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor !== "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === "default") return "navbar-default";
      else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },

    orgData() {
      return this.$store.state.organization.orgData;
    },

    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      },
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  watch: {
    reduce(val) {
      const verticalNavMenuWidth = val
        ? "reduced"
        : this.$store.state.windowWidth < 1200
        ? "no-nav-menu"
        : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    closeActivitySidebar() {
      this.activeActivitySidebar = false;
    },
    async fetchOrgActivityLogData() {
          try {
              if(this.orgData._id) {
                this.fetchingActivityLog = true;
                this.activityLogData = await this.$store.dispatch('organization/fetchOrgActivityLogData', { organizationId: this.orgData._id });
                this.fetchingActivityLog = false;
            }
          } catch (err) {
              throw err;
          }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalNavMenuWidth",
            verticalNavMenuWidth
          );

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
  },
};
</script>

<style>
@media (min-width: 1201px) {
  .main-vertical .vx-navbar-wrapper {
    /* width: calc(100% - 260px); */
    /* width: 100%; */
    /* padding-left: calc(100% - 500px); */
  }

  /* .vs-navbar {
    background: #F8F8F8 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    opacity: 1;
  } */

  .navbar-floating .vx-navbar {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>

